import { action, makeObservable, observable, runInAction } from "mobx";
import { authService } from "@/services/AuthService";
import { addNotification } from "@/utils/addNotification";

export interface WaitingUtilsProps {
  error?: string | undefined;
  waiting: boolean | undefined;
  success?: boolean;
  response?: boolean;
  message?: string;
  csrf_token?: string;
  viewResultAfterLoader: boolean;
}

export class WaitingUtils {
  error?: string | undefined;
  waiting: boolean | undefined;
  success?: boolean;
  response?: boolean = false;
  message?: string;
  csrf_token?: string;
  viewResultAfterLoader: boolean = false;
  //eslint-disable-next-line
  private checkAuth?: any;
  //eslint-disable-next-line
  constructor(checkAuth?: any) {
    this.checkAuth = checkAuth;
    makeObservable(this, {
      error: observable,
      waiting: observable,
      success: observable,
      response: observable,
      message: observable,
      csrf_token: observable,
      viewResultAfterLoader: observable,
      setViewResultAfterLoader: action,
      setError: action,
      setSuccess: action,
      clear: action,
      setData: action,
    });
  }

  setViewResultAfterLoader = (value: boolean): void => {
    this.viewResultAfterLoader = value;
  };

  setError = (error: string, success: boolean): void => {
    this.success = success;
    this.error = error;
    this.response = false;
    this.waiting = false;
    this.viewResultAfterLoader = true;
  };

  setSuccess = (message: string, success?: boolean): void => {
    this.success = success || true;
    this.error = "";
    this.response = false;
    this.waiting = false;
    this.message = message;
    this.viewResultAfterLoader = true;
  };

  clear = () => {
    this.error = "";
    this.waiting = false;
    this.success = undefined;
    this.response = false;
    this.message = undefined;
    this.viewResultAfterLoader = false;
  };

  //eslint-disable-next-line
  async setData<D, F extends (...args: any[]) => Promise<D>>(data: D, responseFn: F) {
    runInAction(() => {
      this.waiting = true;
    });
    try {
      //eslint-disable-next-line
      const result: any = await responseFn(data);

      this.response = true;

      if (result.success) {
        if (result.data && result.data.csrf_token) {
          authService.setCsrfToken(result.data.csrf_token || "");
        }
        this.setSuccess(result.message || "");
      } else {
        this.setError(result.message || "", result.success);
      }
      this.checkAuth?.();
    } catch (e) {
      const message = e instanceof Error ? e.message : typeof e === "string" ? e : "Unknown error";
      addNotification({ message: message, type: "error" });
    }
  }
}
